import { safeImageUrl } from 'lib/community/model'
import type { NoteImage } from 'lib/dealhunt/types'
import type { LightboxImage } from 'components/community/discussions/Lightbox'

/** A review's photos as the lightbox draws them (full size, alt with its fallback). Type-only
 *  import of the lightbox: its module (and stylesheet) loads when a photo is pressed. */
export function lightboxImages(images: readonly NoteImage[], altFallback: string): LightboxImage[] {
  return images.flatMap(im => {
    const url = safeImageUrl(im.url)
    return url ? [{ url, alt: im.alt ?? altFallback, width: im.width, height: im.height }] : []
  })
}
